export const PANE_MIN_HEIGHT = 180;
export const PANE_MAX_HEIGHT = 360;
